// Contact页面相关数据
// 按规则修改和添加内容即可，请不要更改数据结构以及变量命名
export const contactData = {
    contactList: [
        // 第一个section
        {
            header: "研究生招聘",
            list: [
                // 第一段
                "2024招收名额:xx位博士、xx位硕士、实习生若干，我们期待有志于从事自然语言处理领域的科学研究和落地应用；积极主动、热爱研究或者开发、勤奋刻苦、勇于面对暂时“失败”；对团队、社区、领域有推动发展意识和贡献精神；有长远理想、目标，敢于去想做出领先于这个世界的研究或技术的同学加入我们。",
                // 第二段
                "邮箱：xxx@sjtu.edu.cn，电话：xxxx",
            ],
        },
        // 第二个section
        {
            header: "公司合作 / 顾问咨询",
            list: [
                "在AGI时代，真正的突破还需要多方的合作、交流和推动。只有通过共同努力，我们才能够发挥生成式人工智能的潜力，解锁其在各个领域的价值。",
                "我们将长期投入大量的时间和资源，专注于开发和改进这些技术，并推动其落地为实际可应用的工具和产品。我们相信，这些努力将为实现更智能、更高效的生产方式和商业模式打下坚实的基础。",
                "我们非常欢迎各界的朋友进行交流和合作。通过与我们共同探索这个领域，我们可以互相借鉴经验和知识，共同解决问题，从而实现更好的成果。我们相信，只有通过紧密的合作和协作，我们才能够共同推动生成式人工智能的发展，将其应用于更多的领域和行业，为人类带来更多的福利和贡献。",
                "邮箱：xxx@sjtu.edu.cn，电话：xxxx"
            ],
        }
    ],
}